import type { PageMetaDto } from "shared/dto";

import { getPaginationResponseDefault } from "~/common/defaults/pagination-response.default";
import { getShippingDefault } from "~/common/defaults/shipping.default";
import type { UpdateShippingByIdDto } from "~/common/interfaces/dto/shippings/update-shipping-by-id.dto";
import type { Shipping } from "~/common/interfaces/entities/shipping.interface";

export const useShippingsStore = defineStore("shippings", () => {
	const currentShipping = ref<Shipping>(getShippingDefault());
	const shippings = ref<Shipping[]>([]);
	const meta = ref<PageMetaDto>(getPaginationResponseDefault());

	const getById = (id: number): Promise<Shipping> => {
		return useNuxtApp().$apiFetch<Shipping>(`/shippings/${id}`);
	};
	const patchById = (
		id: number,
		dto: UpdateShippingByIdDto
	): Promise<Shipping> => {
		return useNuxtApp().$apiFetch<Shipping>(`/shippings/${id}`, {
			method: "PATCH",
			body: dto
		});
	};

	return {
		currentShipping,
		shippings,
		meta,

		getById,
		patchById
	};
});
